import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { newDateFormat } from 'constants/dateFormats'

export const NewDateCell = ({ value }) => {
  return !value ? (
    '–'
  ) : (
    <span style={{ textTransform: 'uppercase' }}>
      {format(new Date(value), newDateFormat)}
    </span>
  )
}

NewDateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
